import SupportDialog from './SupportDialog';

export default SupportDialog;
